module.exports = __webpack_public_path__ + "static/Silence On Tourne-8e78fc9fc57ec6afdb8e56d02707aab1.mp3";